<template>
  <main class="affiliates">
    <AppSection
      class="hero"
      :data="{
        img: { src: '/assets/video/affiliates_0.jpg' },
        video: { src: '/assets/video/affiliates_0.mp4' },
      }"
    >
      <AppHeadline
        class="hero__headline"
        :data="{
          content: affiliates.hero.title,
          type: 2,
        }"
      />
      <span class="section__line hero__line"></span>
      <AppParagraph
        class="hero__text"
        :data="{
          content: affiliates.hero.content,
        }"
      />
    </AppSection>

    <AppSection
      class="intro"
      :data="{
        img: {
          src: affiliates.intro.img.src,
          alt: '',
        }
      }"
    >
      <div class="intro__container">
        <AppHeadline
          class="intro__headline"
          :data="{
            content: affiliates.intro.title,
            type: 2,
          }"
        />
        <AppParagraph
          class="intro__text intro__text--margin"
          :data="{
            content: affiliates.intro.content[0],
          }"
        />
        <span class="section__line intro__line"></span>
        <AppParagraph
          class="intro__text"
          :data="{
            content: affiliates.intro.content[1],
          }"
        />
      </div>
    </AppSection>

    <AppSection
      class="first-block"
      :data="{
        img: {
          src: affiliates.firstBlock.img.src,
          alt: '',
        }
      }"
    >
      <AppHeadline
        class="first-block__headline"
        :data="{
          content: affiliates.firstBlock.title,
          type: 2,
        }"
      />
      <span class="section__line first-block__line"></span>
      <AppParagraph
        class="first-block__text"
        :data="{
          content: affiliates.firstBlock.content,
        }"
      />
    </AppSection>

    <AppFooter />
  </main>
</template>

<script>
import { TweenMax, TimelineMax, Power4 } from 'gsap/TweenMax';
import IScroll from 'iscroll/build/iscroll-probe';
import scrollMagic from '@/scripts/scrollMagic';
import { isMobile } from '@/scripts/utils';

import AppSection from '@/components/AppSection.vue';
import AppHeadline from '@/components/AppHeadline.vue';
import AppParagraph from '@/components/AppParagraph.vue';
import AppFooter from '@/components/AppFooter.vue';

import affiliates from '@/assets/data/affiliates.json';


export default {
  name: 'Affiliates',
  components: {
    AppHeadline,
    AppParagraph,
    AppSection,
    AppFooter,
  },
  data() {
    return {
      affiliates,
    };
  },
  mounted() {
    this.init();
    this.enter();

    // init controller
    this.controller = new scrollMagic.Controller({ container: '.app__container--affiliates' });
    this.intro();
    this.firstBlock();

    if (isMobile()) {
      // configure iScroll
      this.myScroll = new IScroll('.app__container', {
        scrollX: false,
        scrollY: true,
        scrollbars: true,
        useTransform: false,
        useTransition: false,
        probeType: 3,
        click: true,
        disablePointer: true,
        disableTouch: false,
        disableMouse: false,
      });

      this.controller.scrollPos(() => -this.myScroll.y);

      this.handlerScroll = () => this.controller.update(true);
      this.myScroll.on('scroll', this.handlerScroll);
    }
  },
  methods: {
    init() {
      TweenMax.set('.hero .section__bg', { autoAlpha: 0, scale: 1.5 });
      TweenMax.set('.hero .hero__headline', { autoAlpha: 0, y: 50 });
      TweenMax.set('.hero .hero__line', { scaleY: 0, transformOrigin: '50% 0' });
      TweenMax.set('.hero .hero__text', { autoAlpha: 0, y: 50 });
    },
    enter() {
      const tl = new TimelineMax({ delay: 0.5 });

      tl.addLabel('start')
        .to('.hero .section__bg', 2, {
          autoAlpha: 1,
          scale: 1,
          ease: Power4.easeOut,
        })
        .to('.hero__headline', 1, {
          y: 0,
          autoAlpha: 1,
          ease: Power4.easeOut,
          clearProps: 'all',
        }, 'start')
        .to('.hero__line', 1, {
          scaleY: 1,
          ease: Power4.easeOut,
        }, 'start+=0.25')
        .to('.hero__text', 1, {
          autoAlpha: 1,
          y: 0,
          ease: Power4.easeOut,
          clearProps: 'all',
        }, 'start+=0.5');
    },
    intro() {
      const title = this.$el.querySelector('.intro .intro__headline');
      const line = this.$el.querySelector('.intro .intro__line');
      const texts = Array.from(this.$el.querySelectorAll('.intro .intro__text'));
      const calcY = (window.innerHeight / 2)
        - title.offsetTop - (title.getBoundingClientRect().height / 2);

      TweenMax.set(line, { scaleY: 0, transformOrigin: '50% 0' });
      TweenMax.set(texts[0], { autoAlpha: 0, y: 50 });
      TweenMax.set(texts[1], { autoAlpha: 0, y: 50 });
      TweenMax.set('.intro .intro__headline', { autoAlpha: 0, y: 50 });
      TweenMax.set('.intro .intro__container', { y: calcY });
      TweenMax.set('.intro .section__bg', { height: 'calc(100% + 160px)' });

      const tween = TweenMax.to('.intro .intro__headline', 1, {
        autoAlpha: 1,
        y: 0,
        ease: Power4.easeOut,
      });

      const tl = new TimelineMax();
      tl.addLabel('start')
        .to(texts[0], 1, {
          y: 0,
          autoAlpha: 1,
          clearProps: 'all',
          ease: Power4.easeOut,
        }, 'start+=0.15')
        .to('.intro .intro__container', 1, {
          y: 0,
          ease: Power4.easeOut,
        }, 'start+=0.30')
        .to(line, 1, {
          scaleY: 1,
          ease: Power4.easeOut,
        }, 'start+=0.45')
        .to('.intro .section__bg', 1, {
          y: -160,
        }, 'start+=0.15')
        .to(texts[1], 1, {
          y: 0,
          autoAlpha: 1,
          clearProps: 'all',
          ease: Power4.easeOut,
        }, 'start+=0.50');

      this.introScene1 = new scrollMagic.Scene({
        offset: window.innerHeight,
      })
        .setTween(tween)
        .addTo(this.controller);

      this.introScene2 = new scrollMagic.Scene({
        duration: 800,
        offset: window.innerHeight,
      })
        .setTween(tl)
        .setPin('.affiliates')
        .addTo(this.controller);
    },
    firstBlock() {
      TweenMax.set('.first-block__headline', { autoAlpha: 0, y: 50 });
      TweenMax.set('.first-block__line', { scaleY: 0, transformOrigin: '50% 0' });
      TweenMax.set('.first-block__text', { autoAlpha: 0, y: 50 });

      const tl = new TimelineMax();
      tl.addLabel('start')
        .to('.first-block__headline', 1, {
          y: 0,
          autoAlpha: 1,
          ease: Power4.easeOut,
          clearProps: 'all',
        }, 'start')
        .to('.first-block__line', 1, {
          scaleY: 1,
          ease: Power4.easeOut,
        }, 'start+=0.25')
        .to('.first-block__text', 1, {
          autoAlpha: 1,
          y: 0,
          ease: Power4.easeOut,
          clearProps: 'all',
        }, 'start+=0.5');

      this.firstBlockScene = new scrollMagic.Scene({
        offset: (window.innerHeight * 1.5) + 800,
      })
        .setTween(tl)
        .addTo(this.controller);
    },
  },
  beforeDestroy() {
    if (isMobile() && navigator.userAgent.indexOf('OS 13_') < 0 && navigator.userAgent.indexOf('Safari') > 0) {
      this.myScroll.off('scroll', this.handlerScroll);
      this.myScroll.destroy();
      this.myScroll = null;
    }
    this.controller.destroy();
    this.controller = null;
    this.introScene1.destroy();
    this.introScene1 = null;
    this.introScene2.destroy();
    this.introScene2 = null;
  },
};
</script>

<style lang="scss" scoped>
.affiliates {
  .hero,
  .intro,
  .first-block,
  .intro__container {
    align-items: center;
    justify-content: center;
    flex-flow: column nowrap;

    &__text {
      max-width: 340px;
      text-align: center;
    }
  }

  .intro__container {
    display: flex;
  }

  .intro__text--margin {
    margin-top: 80px;
  }
}
</style>
